var map = {
	"./register-down.png": "9895",
	"./register-label-Floete.png": "b603",
	"./register-label-Posaune.png": "bcbc",
	"./register-label-Prinzipal.png": "7fb0",
	"./register-up.png": "2f02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "356a";